// CloudinaryImage.jsx
import React from 'react';
import { Cloudinary } from '@cloudinary/url-gen';
import { AdvancedImage } from '@cloudinary/react';
import { quality, format } from '@cloudinary/url-gen/actions/delivery';
import { getImageAltText } from '@common/utils/utils';
import { scale } from "@cloudinary/url-gen/actions/resize";

const CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'dci1aiukm';

const cld = new Cloudinary({
  cloud: {
    cloudName: CLOUDINARY_CLOUD_NAME,
  },
});

const CloudinaryAdvancedImage = (
  {
    imagePublicId,
    altText,
    imageQuality = 'auto',
    imageFormat = 'auto',
    style = {},
    className = '',
    type = null
  }
) => {

  let myImage = null


  const getResizeWidth = () => {
    if (type === "original") return null;
    if (window.innerWidth < 800) {
      return Math.round(window.innerWidth); // Default case
    }
    if (type === "by2") return Math.round(window.innerWidth / 2);
    if (type === "by3") return Math.round(window.innerWidth / 3);
    if (type === "by4") return Math.round(window.innerWidth / 4);
    return Math.round(window.innerWidth); // Default case
  };

  const buildImage = () => {
    const img = cld.image(imagePublicId);
    const resizeWidth = getResizeWidth();
    if (resizeWidth) {
      img.resize(scale().width(resizeWidth));
    }
    img.delivery(quality(imageQuality)).delivery(format(imageFormat));
    return img;
  };

  myImage = buildImage();

  if (type === "original") {
    myImage = cld
      .image(imagePublicId)
      .delivery(quality(imageQuality))
      .delivery(format(imageFormat));
  } else {
    // Use a safe default width instead of window.innerWidth to avoid SSR issues
    const safeWidth = typeof window !== "undefined" ? window.innerWidth : 800;
    myImage = cld
      .image(imagePublicId)
      .resize(scale().width(safeWidth))
      .delivery(quality(imageQuality))
      .delivery(format(imageFormat));
  }

  return (
    <>
      <AdvancedImage
        cldImg={myImage}
        alt={altText ? altText : getImageAltText(imagePublicId) || ''}
        style={
          style && Object.keys(style).length > 0
            ? {
                width: "100%",
                height: "auto",
                display: "block",
                objectFit: "cover",
                ...style,
              }
            : undefined
        }
        className={className ? className : undefined}
        loading="lazy"
        decoding="async"
        crossOrigin="anonymous"
        onError={(e) => {
          e.currentTarget.onerror = null; // prevents looping
          e.currentTarget.src = "https://res.cloudinary.com/dci1aiukm/image/upload/v1761118556/sansaar-placeholder.webp";
        }}
      />
    </>

  );
};

export default CloudinaryAdvancedImage;
